export const gatewayName = 'erwin-gateway';
